import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const CareerDateRange = ({selectedDate, selectedPeriod, formats, careerData}) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <div className="dateRanges">
                <span>{t('career.range.all')}</span>
                <span>
                    {
                        moment(selectedDate[selectedPeriod].start).format(formats.header[selectedPeriod])
                    }
                </span>
                <span>{t('career.range.lastWeek')}</span>
            </div>
            <div className="dateRanges">
                {
                    (careerData.allTimePlayerWinLoss || 
                    careerData.dailyPlayerWinLoss || 
                    careerData.last7PlayerWinLoss || 
                    careerData.last30PlayerWinLoss || 
                    careerData.last365PlayerWinLoss) && (
                            <React.Fragment>
                                <span className={`${careerData.allTimePlayerWinLoss < 0 ? 'negativeRake' : 'positiveRake'}`}>{careerData.allTimePlayerWinLoss}</span>
                                <span className={`${careerData[formats.winLoss[selectedPeriod]] < 0 ? 'negativeRake' : 'positiveRake'}`}>{careerData[formats.winLoss[selectedPeriod]]}</span> 
                                <span className={`${careerData.last7PlayerWinLoss < 0 ? 'negativeRake' : 'positiveRake'}`}>{careerData.last7PlayerWinLoss}</span>
                            </React.Fragment>
                        )
                }
            </div>
            <div className="dateRanges vipRow">
                <span className={`vipGoldIcon`}></span>
                <span className={`vipGoldText`}>{t('career.range.purchase')}</span> 
                <span className={`vipGoldArrow`}></span>
            </div>
        </React.Fragment>
    )
}

export default CareerDateRange;